<div class="moduleContainer" *ngIf="translations && customer && card">
  <div class="barcodeContainer" style="height: 0;visibility: hidden;">
    <svg id="barcode" style="height: 0;"></svg>
  </div>
  <br />
  <div class="infoCustomer" *ngIf="show.customerInfo">
    <h2>{{customer.cognome}} {{customer.nome}} - {{card.cardNo}}</h2>
  </div>
  <br />
  <br />
  <button *ngIf="show.download" pButton type="button" class="k-generic-btn" icon="fa fa-download" iconPos="left" label="{{'upload.download_toSign' | translate}}" (click)="onClickScaricaModuloVuoto()"></button>
  <br />
  <br />
  <br />
  <div class="" *ngIf="!currentExistingFiles || (currentExistingFiles.length && currentExistingFiles.length == 0)"><p>{{'upload.no_files_uploaded' | translate}}</p></div>
  <div class="" *ngFor="let file of currentExistingFiles;let i=index;">
    <div class="" *ngIf="file.exist">
      <p-button pTooltip="{{'upload.download_file' | translate}}" label="" icon="fa fas fa-file" styleClass="ui-button-info" (onClick)="onClickShowFile(file)"></p-button>
      <span></span>
      &nbsp;{{file.date | date: 'dd/MM/yyyy'}} - {{file.originalFileName}}
      <br />
      <br />
    </div>
  </div>
  <br />
  <br />
  <div class="noUpload" *ngIf="!show.download || !show.available">
    <p>{{'upload.no_upload_available' | translate}}</p>
  </div>
  <div class="uploadMoule" *ngIf="show.download && show.available">
    <p>{{'upload.upload_file_info' | translate}}</p>
    <p-fileUpload #upload data-testid="upload" name="upload" customUpload="true" [chooseLabel]="translations['upload.choose_file']" [multiple]="false" auto="true" (uploadHandler)="onFileUpload($event, upload)" (onRemove)="onClearUpload()"></p-fileUpload>
  </div>
  <br />
  <br />
  <div class="" *ngIf="file">
    <button pButton class="k-generic-btn" (click)="onClickSave()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}" ></button>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/upload-mg/uploadmg.component.html